import React, { useState, useEffect } from 'react';
import { AppHelper } from '../../helpers/AppHelper';
import { ApiHelper } from '../helpers/ApiHelper';
import { AppConfig } from '../../AppConfig';

export const AppContext = React.createContext({
  appData: {},
  appContextStateHandler: () => { }
})

export const AppContextProvider = (props) => {
  const [state, setState] = useState({ toggleDrawer: true })

  function appContextStateHandler(keyValues) {
    const updateParams = {}
    for (const k in keyValues) {
      updateParams[k] = keyValues[k]
    }
    setState({ ...state, ...updateParams })
  }

  const orgId = AppHelper.parseOrgId(window.location.pathname)

  useEffect(()=>{
    try{
      if(!orgId || orgId === 'PRODUCT') {
        appContextStateHandler({ org: { title: AppConfig.COMPANY_NAME || '', logo: AppConfig.LOGO }})
        return
      }
      const fetchOrg = async () => {
        const response = await ApiHelper.callAwait({ method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', orgId], { pb: 'fieldWhitelabel' }) })
        appContextStateHandler({ org: { ...response, title: response.title || '', logo: response.logo || AppConfig.LOGO }})
      }
      fetchOrg()
    } catch(error) {
      console.log(error)
      appContextStateHandler({ org: { title: AppConfig.COMPANY_NAME || '', logo: AppConfig.LOGO }})
    }
  }, [orgId])

  return (
    <AppContext.Provider value={{ appData: state, appContextStateHandler }}>
      {props.children}
    </AppContext.Provider>
  )
}


// WEBPACK FOOTER //
// ./src/common/contexts/AppContext.js